mi:
  clientForm:
    'no': kāo
    'yes': āe
  datepicker:
    phrases:
      close: Kati
      datepickerEndDateLabel: 'Rā whakamutunga:'
      datepickerEndDatePlaceholder: Tīpako rā
      datepickerStartDateLabel: 'Rā tīmata:'
      datepickerStartDatePlaceholder: Tīpako rā
      endDateAriaLabel: Rā whakamutunga
      endDatePlaceholder: Rā whakamutunga
      resetDates: Rā tautuhi anō
      startDateAriaLabel: Rā tīmata
      startDatePlaceholder: Rā tīmata
  productDetails:
    5 days: 5 ngā rā
  uploader:
    fileLimitHitWithCount: 'Ka taea te tukuatu i ngā kōnae {{count}} anake'
    uploaderText: 'Drag and drop {{files}} here or click to open your file browser {{browse}}'
